const staticPixels = "";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING","FUNCTIONAL"];

export { staticPixels };
export { pixelsCategories };